<div class="doctype">
  <label for="cname">Select Document Types</label>
  <div class="dropdown-container">
    <button class="btn btn-default dropdown-toggle" type="button" id="menu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <span>{{selectedDocs}}</span>
      <span class="caret"></span>
    </button>
    <div class="dropdown-menu" role="menu" aria-labelledby="menu1">
      <div class="dropdown-item">
        <a href="javascript:;" (click)="checkAll($event)" class="checkbox-lbl">Clear All</a>
        <!--<input type="checkbox" class="checkbox" (click)="checkAll($event)" [(ngModel)]="isChecked" [ngStyle]="{'background-color':isChecked ? '#3e697d' : '' }">&nbsp;
        <label *ngIf="!isChecked">Select All</label>
        <label *ngIf="isChecked">Unselect All</label>
        <label class="checkbox-lbl"> Clear All</label>-->
      </div>
      <div role="presentation" *ngFor="let doctype of utilityobj.doctypes ">
        <div class="dropdown-item" role="menuitem" >
          <input type="checkbox" class="checkbox" (change)="docSelected(doctype)" [(ngModel)]="doctype.isChecked" [ngStyle]="{'background-color':doctype.isChecked ? '#3e697d' : '' }">&nbsp;
          <label class="checkbox-lbl">  {{doctype.docName}}</label>
        </div>
      </div>
    </div>
  </div>
</div>
